import { useEffect, useState } from 'react';
import { Form } from 'react-final-form';
import { useHistory } from 'react-router-dom';

import { backendAnalyticsTrack } from 'analytics/backend';
import GlobalLoader from 'components/GlobalLoader';
import NavigatorContent from 'components/NavigatorContent';
import { InitialValues } from 'forms/types';
import useNavigatorTracking from 'hooks/useNavigatorTracking';
import Steps from 'hooks/useNavigatorTracking/steps';
import { OCCUPATION_PATH } from 'routes/paths';

import { HEADING } from './constants';
import BasicsForm from './form';
import { BasicsFormValues } from './form/types';
import { useGetBasicsQuery } from './graphql/GetSurveyBasics';
import { useUpdateBasicsMutation } from './graphql/UpdateBasics';
import SelectUser from './SelectUser';
import buildInitialValues from './utils/buildInitialValues';
import { validate } from './utils/validate';

const Basics = () => {
  const trackStepCompleted = useNavigatorTracking(Steps.SurveyBasics);
  const [showSelectUser, setShowSelectUser] = useState(true);
  const { data, loading } = useGetBasicsQuery();
  const initialValues = buildInitialValues(data);
  const [updateBasics] = useUpdateBasicsMutation({
    onCompleted: () => onCompleted(),
  });
  const history = useHistory();

  useEffect(() => {
    backendAnalyticsTrack({
      action: 'track_disability_navigator_start',
    });
  }, []);

  const onCompleted = () => {
    trackStepCompleted();
    history.push(OCCUPATION_PATH);
  };

  const onSubmit = (values: BasicsFormValues) =>
    updateBasics({
      variables: {
        input: {
          dateOfBirth: values.dateOfBirth,
          gender: values.gender,
          stateId: values.stateId,
        },
      },
    });

  if (loading) {
    return <GlobalLoader />;
  }

  if (showSelectUser && !!data?.currentUser.email) {
    return (
      <SelectUser
        firstName={data?.currentUser.firstName ?? ''}
        setShowSelectUser={setShowSelectUser}
      />
    );
  }

  return (
    <NavigatorContent heading={HEADING} title={Steps.SurveyBasics}>
      <Form<BasicsFormValues, InitialValues<BasicsFormValues>>
        initialValues={initialValues}
        onSubmit={onSubmit}
        validate={validate}
      >
        {(formProps) => <BasicsForm {...formProps} />}
      </Form>
    </NavigatorContent>
  );
};

export default Basics;
